import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/style.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import MultiSignalsAlerts from './components/MultiSignalsAlerts/MultiSignalsAlerts';
import MultiSignalsLoadingFull from './components/MultiSignalsLoadingFull/MultiSignalsLoadingFull';

const app = (
  <Provider store={store}>
    <MultiSignalsAlerts />
    <MultiSignalsLoadingFull/>
    <App />
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
